import icon from "../../assets/access-hub.svg";
import type { Property } from "../../types";

export const includedHub: Property = {
  id: "includedHub",
  title: "includedHub.title",
  icon,
};
